export default __webpack_public_path__ + "static/media/Q14_0_resized.fbf9fe5c.jpg";